import { render, staticRenderFns } from "./KelvinWaterDropperViz.vue?vue&type=template&id=35baac46&scoped=true"
import script from "./KelvinWaterDropperViz.vue?vue&type=script&lang=js"
export * from "./KelvinWaterDropperViz.vue?vue&type=script&lang=js"
import style0 from "./KelvinWaterDropperViz.vue?vue&type=style&index=0&id=35baac46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35baac46",
  null
  
)

export default component.exports